import { Button } from 'solid-bootstrap';

export function CopyClipboard(props) {
    const doCopy = () => {
        navigator.clipboard.writeText(props.text);
    };
    return <div class="copy-clipboard-container d-flex flex-row gap-3">
        <pre><code>{props.text}</code></pre>
        <Button onClick={doCopy}>Copy to clipboard</Button>
    </div>
}